module.exports = __webpack_public_path__ + "img/logo-footer-7.d3e48365.png";